import React from 'react';

import BaseLayout from 'ff/debrief/layouts/BaseLayout';
import Header from 'ff/debrief/components/Header';
import Map from 'ff/debrief/components/map/Map';
import ModalManager from 'ff/debrief/modalManager';

const MapGridLayout = (props: React.PropsWithChildren) => {
    return (
        <BaseLayout>
            <Header></Header>
            <Map>{props.children}</Map>
            <ModalManager />
        </BaseLayout>
    );
};

export default MapGridLayout;
